import React, { FunctionComponent, memo } from 'react';
import { useDataStore } from '../../../zustand';
import { IRoot, ISceneComp, ITrackingTypes } from '../../r3f-components/component-data-structure';
import OriginContent from './OriginContent';

const ScenesOriginContent: FunctionComponent = () => {
	const componentsById = useDataStore(({componentsById}) => componentsById);
	const rootId = useDataStore(({rootId}) => rootId!);

	if (!componentsById || !rootId) return null;

	const faceTrackedSceneIds = (componentsById[rootId] as IRoot).children.filter((id) => (componentsById[id] as ISceneComp).trackingType === ITrackingTypes.face);

	return (
		<>
			{faceTrackedSceneIds.map((sceneId) => {
				return <OriginContent key={sceneId} sceneId={sceneId} />;
			})}
		</>
	);
};

ScenesOriginContent.displayName = 'ScenesOriginContent';
export default memo(ScenesOriginContent);
